module.exports = __webpack_public_path__ + "img/icon-warning-stormflo-2.4759d2de.svg";